import { useState } from "react";
import GetTime from "../../utils/gettime";

export default function PostBoxContent({ item }) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="sm:p-4 p-2.5 border-t border-gray-100 font-normal space-y-3 relative dark:border-slate-700/40">
      {item.p_title !== "" && (
        <div>
          <p className={!isExpanded ? "line-clamp-2" : ""}>
            {item.p_title}
          </p>

          {item.p_title && item.p_title.length > 80 && (
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="text-blue-600 hover:underline font-medium text-sm mt-1 focus:outline-none"
            >
              {isExpanded ? "Show Less" : "More..."}
            </button>
          )}
        </div>
      )}

      <p style={{ fontSize: 12 }}>{GetTime(item.p_update)}</p>
    </div>
  );
}